module.exports = __webpack_public_path__ + "static/media/attention.fc69f2b7.gif";